import "@fontsource-variable/onest/wght.css";
import "@fontsource/cormorant/cyrillic-400.css";
import "@fontsource/cormorant/latin-400.css";
import "@fontsource/cormorant/cyrillic-500.css";
import "@fontsource/cormorant/latin-500.css";
import "./styles.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { getConfig } from "./lib/api";
import { startBackgroundSync } from "./lib/sync";
import { installAudioUnlock } from "./lib/audio/unlock";

// Конфиг (версия движка, CDN) и синк — в фоне; интерфейс рисуется сразу из IndexedDB
void getConfig();
// список голосов и функции сервера меняются (голоса догружаются, включили «Мой голос») — обновляем
document.addEventListener("visibilitychange", () => document.visibilityState === "visible" && void getConfig());
setInterval(() => document.visibilityState === "visible" && void getConfig(), 60_000);
void import("./lib/voiceProfile").then((m) => m.refreshVoiceProfile());
startBackgroundSync();
installAudioUnlock();

// Просим браузер не вытеснять офлайн-данные при нехватке места
void navigator.storage?.persist?.().catch(() => {});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
